<viewer-root
  (menuOpenedChange)="_onMenuOpenedChange($event)"
  (bookLoad)="_onBookLoad($event)"
></viewer-root>
